export default __webpack_public_path__ + "static/media/htmlorg.9b03a845.png";